export const CHANNEL_LOGOUT = 'channel-logout'
